import React from "react";
import {MainTypography} from "../../triton/components/typography/MainTypography";
import {Menu} from "../../ardai/components/Menu";
import {Tag} from "../../ardai/components/Tag";
import {ColorableTag} from "../../ardai/components/ColorableTag";
import {Color} from "../../base/logic/style/Color";
import {useLiveQuery} from "dexie-react-hooks";
import {webDB} from "../../ardai/webapi/WebAPIDB";
import {MixinData} from "./MixinData";
import {MenuButton} from "../../ardai/components/MenuButton";
import {DeleteRounded} from "@mui/icons-material";

export type MixinCardProps = {
    for: MixinData,
    onSelect?: () => void,
}

export const MixinCard: React.FC<MixinCardProps> = props => {
    return (
        <div onClick={() => {
            props.onSelect?.();
        }} style={{
            padding: "1rem",
            width: "100%",
            backgroundColor: "#1e202a",
            borderRadius: "8px",
            cursor: "pointer"
        }}>
            <div style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "8px"
            }}>
                <MainTypography text={
                    <>@<strong style={{ color: "#ffc66d" }} children={props.for.key}/></>
                } style={{
                    fontFamily: "Consolas, Courier New, monospace"
                }}/>

                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                }}>
                    {/*}
                    <ColorableTag
                        tag={"link"}
                        c={Color.ofHex("#ffc66d")}
                    />
                    <ColorableTag
                        tag={"func"}
                        c={Color.ofHex("#d2a8ff")}
                    />
                    */}
                    <ColorableTag
                        tag={"constant"}
                        c={Color.ofHex("#79c0ff")}
                    />

                    <Menu>
                        <MenuButton text={"Delete"} icon={<DeleteRounded/>} onSelect={() => {
                            // e.stopPropagation();
                            // e.preventDefault();
                            webDB.mixins.delete(props.for.id);
                        }}/>
                    </Menu>
                </div>
            </div>
        </div>
    );
}
